let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lG1hy")).then(() => parcelRequire('e1e78'));